import { ROUTER_BASENAME } from './routerBasename';

/**
 * Configuration for the public legal pages (AD-LP-5).
 *
 * Every value has a production-safe default so the pages never render a blank
 * or placeholder value if an environment variable is missing.
 */

/** Support mailbox shown in the Contact sections. */
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@stacktrack.app';

/** Jurisdiction named in the Terms "Governing Law" section. */
export const GOVERNING_LAW = process.env.REACT_APP_GOVERNING_LAW || 'the Republic of India';

/** Single revision date for all three documents. */
export const LAST_UPDATED = 'August 2026';

/**
 * Formats a platform array as "A, B, C and D" for prose.
 * @param {string[]} platforms
 */
export function formatPlatformList(platforms) {
  return platforms.join(', ').replace(/, ([^,]*)$/, ' and $1');
}

/**
 * Absolute origin the canonical URLs are built from.
 *
 * Derived from the browser so dev, staging and production are each correct
 * without configuration; `REACT_APP_PUBLIC_SITE_URL` overrides when the
 * canonical public hostname differs from the host actually serving the page.
 */
export function getPublicSiteUrl() {
  const override = process.env.REACT_APP_PUBLIC_SITE_URL;
  if (override) return String(override).replace(/\/$/, '');
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}${ROUTER_BASENAME}`;
}

/**
 * Absolute canonical URL for a router path.
 * @param {string} path Router path such as `/privacy` (no basename — see AD-LP-1).
 */
export function canonicalUrl(path) {
  return `${getPublicSiteUrl()}${path}`;
}

/** Router paths for the three public legal documents. */
export const LEGAL_ROUTES = {
  privacy: '/privacy',
  terms: '/terms',
  accountLinking: '/account-linking',
};

/** Footer / cross-document navigation (AD-LP-7). */
export const LEGAL_NAV_LINKS = [
  { label: 'Privacy Policy', to: LEGAL_ROUTES.privacy },
  { label: 'Terms of Service', to: LEGAL_ROUTES.terms },
  { label: 'Account Linking', to: LEGAL_ROUTES.accountLinking },
];

/** Coding platforms a student can link a username for. */
export const LINKABLE_PLATFORMS = [
  'LeetCode',
  'Codeforces',
  'CodeChef',
  'GeeksforGeeks',
  'HackerRank',
];

/**
 * Platforms the Chrome extension itself reads.
 *
 * Deliberately narrower than {@link LINKABLE_PLATFORMS}: it mirrors the
 * extension's declared `host_permissions`, which a Chrome Web Store reviewer
 * compares against this policy. Update both together.
 */
export const EXTENSION_PLATFORMS = [
  'LeetCode',
  'CodeChef',
  'Codeforces',
  'GeeksforGeeks',
];
